import { Id } from '../aliases.js'
import AgentStatusCodes from '../agent/agentStatusCodes.js'
import { CborMap } from '@mesh/friendly-cbor-serializer'
import AgentMessageTypes from '../agent/agentMessageTypes.js'

export interface MeshAppMessage {
  kind?: string
}

export interface MeshAppRequestMessage extends MeshAppMessage {
  id: Id
  status?: AgentStatusCodes
  statusMessage?: string
  type: AgentMessageTypes
  payload?: CborMap
}

export interface MeshAppNavigationMessage extends MeshAppMessage {
  url: string
  newTab?: boolean
  isMeshAppInternalNavigation?: boolean
}

export const navigationMessageKind = 'host:navigate'

export const requestMessageKind = 'host:request'

export const notificationMessageKind = 'host:notification'
